// require( "jquery-ui/ui/widgets/autocomplete" );
const { loadScript, loadStyle } = require('./util/loadDependencies');


export default (jsBasePath) => jQuery(($) => {
	const dataList = () => {

		$('.datalist').each(function () {
			let input = $(this);
			let selector = '#' + input.attr('id') + '_options option';
			let valueSelector = '#' + input.attr('id') + '_value';
			let queryParams = new URLSearchParams(location.search);
			console.log(this.id);

			let listener = document.querySelector('input#'+this.id);
			listener.addEventListener('input', (e) => {
				if (input.val().length === 0) {
					$(valueSelector).val('');
				}
			});

			let existing = queryParams.get($(valueSelector).attr('name'));
			if (existing) {
				$(selector).map((index, options) => {
					if (options.attributes.value.value == existing) {
						input.val(options.text);
						$(valueSelector).val(existing);
					}
				});
			}

			new autoComplete({
				selector: input[0],
				menuClass: 'carleton-advance--high-ed-lookup__results',
				source: function(term, response) {
					let availableTags = [];
					$(selector).map((index, options) => {
						if (options.text.toLowerCase().indexOf(term.toLowerCase()) >= 0) {
							availableTags.push(options.text);
						}
					});
					response(availableTags || [{'noresults': true}]);
				},
				renderItem: function (item, search) {
					// escape special characters
					// search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
					// var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");

					//
					// var returnString = item.label.replace(re, "<b>$1</b>");
					// var location = [];
					// if (item.city) location.push(item.city.replace(re, "<b>$1</b>"));
					// if (item.state) location.push(item.state.replace(re, "<b>$1</b>"));
					// if (item.country) location.push(item.country.replace(re, "<b>$1</b>"));
					// if (location.length) returnString += ` (${location.join(', ')})`;

					search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
					var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");

					if (item.noresults) {
						return '<div class="autocomplete-suggestion"><b>' + search + '</b> (not found)</div>';
					}

					return '<div class="autocomplete-suggestion" data-val="' + item + '">' + item.replace(re, "<b>$1</b>") + '</div>';

					// return `<div class="autocomplete-suggestion" data-code="${item.code.replace(/"/g, '&quot;')}" data-val="${item.label.replace(/"/g, '&quot;')}" data-label="${returnString.replace(/"/g, '&quot;').replace(/<\/?b>/g, '')}">${returnString}</div>`;
				},
				onSelect: function(e, term, item) {
					let termVal = $(selector +':contains('+term+')').val();
					$(valueSelector).val(termVal);
				}
			});
			// input.autocomplete({
			// 	minLength: 2,
			// 	delay: 100,
			// 	source: availableTags,
			// 	select: function (event, ui) {
			// 		console.log([event, ui]);
			// 		console.log(ui.item.value);
			// 		console.log(valueSelector);
			// 		$(valueSelector).val(ui.item.value);
			// 	}
			// });
		});
	};

	// loadScript(`${jsBasePath}./autoComplete/auto-complete.min.js`, dataList);
	// loadStyle(`${jsBasePath}./autoComplete/auto-complete.css`);
	// loadScript(`${jsBasePath}./jquery-ui/autocomplete.js`, dataList);
	loadScript(`${jsBasePath}./autoComplete/auto-complete.min.js`, dataList);
});
